// extracted by mini-css-extract-plugin
module.exports = {"TopBlock":"TopBlock_TopBlock__3fXqw","TopBlockWrap":"TopBlock_TopBlockWrap__qDIvM"};